import { nil, NO, UIColor, UITextView, UIView, YES } from "uicore-ts"
import { RHColor } from "../../Custom components/RH/RHColor"


export class InvoiceLineRowView extends UIView {

    readonly descriptionLabel = new UITextView()
        .configuredWithObject({
            backgroundColor: UIColor.transparentColor,
            isSingleLine: NO,
            style: {
                fontSize: "14px",
                lineHeight: "1.4"
            }
        })
        .addedAsSubviewToView(this)

    readonly amountLabel = new UITextView()
        .configuredWithObject({
            backgroundColor: UIColor.transparentColor,
            isSingleLine: YES,
            textAlignment: UITextView.textAlignment.right,
            style: {
                fontSize: "14px",
                fontVariantNumeric: "tabular-nums",
                fontWeight: "500"
            }
        })
        .addedAsSubviewToView(this)

    configure(description: string, amount: string, isOverdue: boolean) {
        this.descriptionLabel.text = description
        this.amountLabel.text = amount
        this.amountLabel.textColor = isOverdue ? RHColor.danger : RHColor.textBlack
    }

    override layoutSubviews() {
        super.layoutSubviews()
        const padding = this.core.paddingLength
        const bounds = this.contentBoundsWithInset(padding * 0.5)
        const amountColumnWidth = padding * 8
        bounds.distributeViewsAlongWidth(
            [this.descriptionLabel, this.amountLabel],
            undefined,
            padding,
            [nil, amountColumnWidth]
        )
    }

    override intrinsicContentHeight(constrainingWidth: number = 0): number {
        const padding = this.core.paddingLength
        const amountColumnWidth = padding * 8
        const descWidth = Math.max(constrainingWidth - amountColumnWidth - padding * 3, 0)
        return padding + [
            this.descriptionLabel.intrinsicContentHeight(descWidth),
            this.amountLabel.intrinsicContentHeight(amountColumnWidth)
        ].max() + padding
    }

}
